module.exports = __webpack_public_path__ + "static/media/talk-3-final-01.49bd423e.png";